export var SET_PRICE_MODELS = 'SET_PRICE_MODELS';
export var SET_TRIM_COUNTS = 'SET_TRIM_COUNTS';
export var SET_PRICE_RANGE = 'SET_PRICE_RANGE';
export var SET_MODEL_KEYS = 'SET_MODEL_KEYS';
export var ADD_ITEM = 'ADD_ITEM';
export var REMOVE_ITEM = 'REMOVE_ITEM';
export var RESET = 'RESET';
export var SET_ONLY_FUTURE_VEHICLES = 'SET_ONLY_FUTURE_VEHICLES';
export var SET_ONLY_NSX = 'SET_ONLY_NSX';
export var ModelFiltersKeys;
(function (ModelFiltersKeys) {
    ModelFiltersKeys["SPECIAL_OFFERS"] = "specialOffers";
    ModelFiltersKeys["ALL_OFFERS"] = "allOffers";
})(ModelFiltersKeys || (ModelFiltersKeys = {}));
